<template>
  <div class="tw-flex tw-flex-col tw-items-center">
    <button @click="exampleStore.increment()">
      Increment
    </button>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useExampleStore } from '@frontend/ui/stores/exampleStore';

export default {
  name: 'PiniaExampleComponent',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useExampleStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
